<template>
    <div class="container" v-if="!isLoading">
        <div class="ms-auto">
            <span class="page-title">{{ title }}</span>
            <Tag :severity="historiqueBlacklist.active ? 'danger' : 'success'"
                 :value="historiqueBlacklist.active ? 'Blacklisté' : 'Whitelisté'"
                 class="mx-3"
                 rounded
            />
            <span>{{ historiqueBlacklist.active ? 'Non traité' : 'Traité' }}</span>
        </div>

        <div class="flex space-x-4 pb-5">
            <div class="mt-7 me-4 w-7/12">
                <BlacklistingTable :data="historiqueBlacklist.blacklists" @filter-comments-by-reason="filterCommentTableByReason" />
            </div>
            <div class="ms-4 w-5/12">
                <UserProfilTable :data="historiqueBlacklist" />
            </div>
        </div>
        <div>
            <BlacklistingCommentTable :data="historiqueBlacklist.comments"/>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {onMounted, ref, computed} from "vue";
import {useRoute} from "vue-router";
import {getUserHistoriqueBlackList} from "@/_services/blackList/blacklist";
import {UserBlacklistComment, UserBlacklistHistorique} from "@/models/blacklisting/UserBlacklistHistorique";
import BlacklistingTable from "@/components/blacklisting/BlacklistingTable.vue";
import UserProfilTable from "@/components/blacklisting/UserProfilTable.vue";
import BlacklistingCommentTable from "@/components/blacklisting/BlacklistingCommentTable.vue";
import Tag from "primevue/tag";

const route = useRoute();
const params = computed(() => route.params);
const isLoading = ref(true);
let savedTable: UserBlacklistComment[] = [];
const title = ref<string>("");
const usersBlackListUuid = Array.isArray(params.value.uuid) ? params.value.uuid.join(",") : params.value.uuid;
const historiqueBlacklist = ref<UserBlacklistHistorique>({} as UserBlacklistHistorique);

onMounted(async () => {
    const [isLoadingDt, historiqueBlacklistData] = await getUserHistoriqueBlackList(usersBlackListUuid);
    title.value = `Historique Blacklisting de ${historiqueBlacklistData.user.firstname} ${historiqueBlacklistData.user.lastname}`;
    isLoading.value = isLoadingDt;
    historiqueBlacklist.value = historiqueBlacklistData;
    savedTable = historiqueBlacklist.value.comments;
    historiqueBlacklist.value.blacklists = historiqueBlacklist.value.blacklists.reverse();
});

let filtered = false;
let lastIndex = "";
const filterCommentTableByReason = (index: string) => {
    if (!filtered || (filtered && lastIndex !== index)) {
        historiqueBlacklist.value.comments = filterTableByUuid(savedTable, index);
        filtered = true;
        lastIndex = index;
    } else if (filtered) {
        historiqueBlacklist.value.comments = savedTable;
        filtered = false;
        lastIndex = index;
    } else {
        historiqueBlacklist.value.comments = filterTableByUuid(historiqueBlacklist.value.comments, index);
        filtered = true;
        lastIndex = index;
    }
};

function filterTableByUuid(table: UserBlacklistComment[], uuid: string): UserBlacklistComment[] {
    return table.filter((item: UserBlacklistComment) => item.uuid === uuid);
}
</script>

<style scoped lang="scss">
.title {
    font-size: 24px;
}

.p-tag {
    font-weight: 400;
}

.separator {
    width: 5%;
    height: 5px;
    background-color: grey;
}
</style>